/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download full-size HD YouTube thumbnails at 1280×720 (maxresdefault). Paste any video URL to grab the highest-resolution thumbnail available. Free.`)
};

const es_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarga miniaturas HD de YouTube a tamaño completo, 1280×720 (maxresdefault). Pega la URL de cualquier video para obtener la miniatura de mayor resolución disponible. Gratis.`)
};

const de_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade YouTube-HD-Thumbnails in voller Größe mit 1280×720 (maxresdefault). URL einfügen und die höchste verfügbare Auflösung holen. Kostenlos.`)
};

const nl_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download HD YouTube-thumbnails op volledig formaat (1280×720, maxresdefault). Plak een video-URL om de thumbnail met de hoogste resolutie te downloaden. Gratis.`)
};

const fr_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez des miniatures YouTube HD en 1280×720 (maxresdefault). Collez l’URL d’une vidéo pour récupérer la plus haute résolution disponible. Gratuit.`)
};

const it_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarica miniature YouTube HD a piena dimensione a 1280×720 (maxresdefault). Incolla l'URL di un video per ottenere la miniatura alla risoluzione più alta disponibile. Gratis.`)
};

const pt_br2_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baixe thumbnails HD do YouTube em 1280×720 (maxresdefault). Cole a URL do vídeo e pegue a maior resolução disponível. Grátis.`)
};

const pt_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descarregue miniaturas HD do YouTube em tamanho completo a 1280×720 (maxresdefault). Cole qualquer URL de vídeo para obter a miniatura de maior resolução disponível. Grátis.`)
};

const ja_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1280×720（maxresdefault）のフルサイズHD YouTubeサムネイルをダウンロード。動画URLを貼り付けるだけで、利用可能な最高解像度のサムネイルを取得できます。無料。`)
};

const zh_yt_hd_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载 1280×720（maxresdefault）全尺寸 HD YouTube 缩略图。粘贴任意视频链接，获取可用的最高分辨率缩略图。免费。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_meta_description", locale)
	if (locale === "en") return en_yt_hd_meta_description(inputs)
	if (locale === "es") return es_yt_hd_meta_description(inputs)
	if (locale === "de") return de_yt_hd_meta_description(inputs)
	if (locale === "nl") return nl_yt_hd_meta_description(inputs)
	if (locale === "fr") return fr_yt_hd_meta_description(inputs)
	if (locale === "it") return it_yt_hd_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_meta_description(inputs)
	if (locale === "pt") return pt_yt_hd_meta_description(inputs)
	if (locale === "ja") return ja_yt_hd_meta_description(inputs)
	return zh_yt_hd_meta_description(inputs)
};